export const awardBidWinner = /* GraphQL */ `
  mutation AwardBidWinner($input: InputAwardBidWinner) {
    awardBidWinner(input: $input) {
      status
      statusDetail
    }
  }
`

export const sendChat = /* GraphQL */ `
  mutation SendChat(
    $to: String!
    $sender: String!
    $receiver: String
    $message: String!
    $type: String!
    $sentAt: String
  ) {
    sendChat(
      to: $to
      sender: $sender
      receiver: $receiver
      message: $message
      type: $type
      sentAt: $sentAt
    ) {
      to
      sender
      receiver
      message
      type
      sentAt
    }
  }
`

export const updateClient = /* GraphQL */ `
  mutation UpdateClient($input: InputUpdateClient) {
    updateClient(input: $input) {
      status
      statusDetail
    }
  }
`

export const cognitoAddUser = /* GraphQL */ `
  mutation CognitoAddUser($input: InputCognitoAddUser) {
    cognitoAddUser(input: $input) {
      result
    }
  }
`

export const advanceSimYear = /* GraphQL */ `
  mutation AdvanceSimYear($input: InputAdvanceSimYear) {
    advanceSimYear(input: $input) {
      status
      statusDetail
    }
  }
`

export const refreshHostCode = /* GraphQL */ `
  mutation RefreshHostCode($input: InputRefreshHostCode) {
    refreshHostCode(input: $input) {
      newCode
      updatedAt
    }
  }
`

export const cognitoUpdateUser = /* GraphQL */ `
  mutation CognitoUpdateUser($input: InputCognitoUpdateUser) {
    cognitoUpdateUser(input: $input) {
      status
      statusDetail
    }
  }
`

export const updateHost = /* GraphQL */ `
  mutation UpdateHost($input: InputUpdateHost) {
    updateHost(input: $input) {
      status
      statusDetail
    }
  }
`

export const addHighProfileIncome = /* GraphQL */ `
  mutation AddHighProfileIncome($input: InputAddHighProfileIncome) {
    addHighProfileIncome(input: $input) {
      id
      teamId
      incomeType
      offeringId
      incomeYear
      profit
      agreedFee
    }
  }
`

export const addOtherIncome = /* GraphQL */ `
  mutation AddOtherIncome($input: InputAddOtherIncome) {
    addOtherIncome(input: $input) {
      id
      teamId
      incomeType
      offeringId
      incomeYear
      profit
    }
  }
`

export const mergeTeams = /* GraphQL */ `
  mutation MergeTeams($input: InputMergeTeams) {
    mergeTeams(input: $input) {
      largerTeam {
        id
        name
      }
      smallerTeam {
        id
        name
      }
    }
  }
`

export const publishStatusUpdate = /* GraphQL */ `
  mutation PublishStatusUpdate(
    $to: String!
    $message: String!
    $type: String!
    $updater: String!
    $updatedAt: AWSDateTime
  ) {
    publishStatusUpdate(
      to: $to
      message: $message
      type: $type
      updater: $updater
      updatedAt: $updatedAt
    ) {
      to
      message
      type
      updater
      updatedAt
    }
  }
`

export const addSimStats = /* GraphQL */ `
  mutation AddSimStats($input: InputAddSimStats) {
    addSimStats(input: $input) {
      offeringId
      numTeams
      updatedAt
    }
  }
`

export const updateSimStats = /* GraphQL */ `
  mutation UpdateSimStats($input: InputUpdateSimStats) {
    updateSimStats(input: $input) {
      offeringId
      numNewTeams
    }
  }
`

export const addTeamStats = /* GraphQL */ `
  mutation AddTeamStats($input: InputAddTeamStats) {
    addTeamStats(input: $input) {
      offeringId
      hostId
      hostName
      teamId
      teamName
      totalProfit
      clientSatisfaction
      employeeSatisfaction
      highProfileRevenue
      createdAt
    }
  }
`

export const refreshTeamCode = /* GraphQL */ `
  mutation RefreshTeamCode($input: InputRefreshTeamCode) {
    refreshTeamCode(input: $input) {
      newCode
      updatedAt
    }
  }
`

export const updateTeam = /* GraphQL */ `
  mutation UpdateTeam($input: InputUpdateTeam) {
    updateTeam(input: $input) {
      status
      statusDetail
    }
  }
`

export const addTeam = /* GraphQL */ `
  mutation AddTeam($input: InputAddTeam) {
    addTeam(input: $input) {
      id
      offeringId
      name
      year
      code {
        id
        code
        role
        updatedAt
      }
    }
  }
`

export const readyToAdvance = /* GraphQL */ `
  mutation ReadyToAdvance($input: InputReadyToAdvance) {
    readyToAdvance(input: $input) {
      status
      statusDetail
    }
  }
`

export const removeOffering = /* GraphQL */ `
  mutation RemoveOffering($input: InputRemoveOffering) {
    removeOffering(input: $input) {
      id
    }
  }
`

export const cognitoDeleteUser = /* GraphQL */ `
  mutation CognitoDeleteUser($input: InputCognitoDeleteUser) {
    cognitoDeleteUser(input: $input) {
      status
      statusDetail
    }
  }
`

export const addBid = /* GraphQL */ `
  mutation AddBid($input: InputAddBid) {
    addBid(input: $input) {
      id
      bidAt
      bidYear
      offeringId
      teamId
      agreedFee
      status
      winningReason
    }
  }
`

export const addOffering = /* GraphQL */ `
  mutation AddOffering($input: InputAddOffering) {
    addOffering(input: $input) {
      id
      hostId
      createdAt
      endedAt
      numTeams
      year
    }
  }
`

export const addLeader = /* GraphQL */ `
  mutation AddLeader($input: InputAddLeader) {
    addLeader(input: $input) {
      id
      updatedAt
      code {
        id
        code
        role
        updatedAt
      }
    }
  }
`
